// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.form-error-wrapper {
  margin-bottom: 1rem;
}

.form-error-wrapper.has-error input,
.form-error-wrapper.has-error select,
.form-error-wrapper.has-error textarea,
.input-error {
  border-color: #dc3545 !important;
  box-shadow: 0 0 0 0.2rem rgba(220, 53, 69, 0.25);
}

.error-messages {
  margin-top: 0.25rem;
  color: #dc3545;
  font-size: 0.875rem;
}

.error-message {
  margin-bottom: 0.25rem;
}

.error-message:last-child {
  margin-bottom: 0;
}`, "",{"version":3,"sources":["webpack://./src/components/common/FormErrorWrapper.css"],"names":[],"mappings":"AAAA;EACE,mBAAmB;AACrB;;AAEA;;;;EAIE,gCAAgC;EAChC,gDAAgD;AAClD;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;AAClB","sourcesContent":[".form-error-wrapper {\n  margin-bottom: 1rem;\n}\n\n.form-error-wrapper.has-error input,\n.form-error-wrapper.has-error select,\n.form-error-wrapper.has-error textarea,\n.input-error {\n  border-color: #dc3545 !important;\n  box-shadow: 0 0 0 0.2rem rgba(220, 53, 69, 0.25);\n}\n\n.error-messages {\n  margin-top: 0.25rem;\n  color: #dc3545;\n  font-size: 0.875rem;\n}\n\n.error-message {\n  margin-bottom: 0.25rem;\n}\n\n.error-message:last-child {\n  margin-bottom: 0;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
